<template>
	<TransitionRoot :show="show" appear as="template">
		<TransitionChild
			as="template"
			enter="transition duration-300 ease-out"
			enter-from="translate-y-full opacity-0"
			enter-to="translate-y-0 opacity-100"
			leave="transition duration-200 ease-in"
			leave-from="translate-y-0 opacity-100"
			leave-to="translate-y-full opacity-0"
		>
			<div
				role="dialog"
				aria-modal="false"
				aria-labelledby="cookie-consent-title"
				class="fixed inset-x-0 bottom-0 z-40 bg-white shadow-[0_-2px_10px_rgba(0,0,0,0.08)] border-t border-gray-200"
			>
				<div
					class="mx-auto max-w-6xl px-4 py-4 sm:px-6 sm:py-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-6"
				>
					<div class="flex-1 text-sm text-gray-800">
						<p id="cookie-consent-title" class="font-semibold mb-1">
							{{ t("cookie.banner.title") }}
						</p>
						<p class="text-gray-600">
							{{ t("cookie.banner.body") }}
							<a
								v-if="privacyUrl"
								:href="privacyUrl"
								class="underline hover:no-underline"
								target="_blank"
								rel="noopener noreferrer"
							>
								{{ t("cookie.privacy_link_text") }}
							</a>
						</p>
					</div>
					<div class="flex flex-col sm:flex-row gap-2 sm:flex-shrink-0">
						<button
							type="button"
							class="px-4 py-2 text-sm font-medium border border-gray-300 rounded hover:bg-gray-50"
							@click="openSettings"
						>
							{{ t("cookie.banner.customize") }}
						</button>
						<button
							type="button"
							class="px-4 py-2 text-sm font-medium border border-gray-300 rounded hover:bg-gray-50"
							@click="rejectAll"
						>
							{{ t("cookie.banner.reject_all") }}
						</button>
						<button
							type="button"
							class="px-4 py-2 text-sm font-medium text-white bg-gray-900 rounded hover:bg-black"
							@click="acceptAll"
						>
							{{ t("cookie.banner.accept_all") }}
						</button>
					</div>
				</div>
			</div>
		</TransitionChild>
	</TransitionRoot>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { TransitionRoot, TransitionChild } from "@headlessui/vue";

const { t } = useI18n();
const runtimeConfig = useRuntimeConfig();
const { hasDecided, acceptAll, rejectAll, openSettings } = useCookieConsent();

const isCustomCmp = computed(() => runtimeConfig.public.cmp === "custom");
const show = computed(() => isCustomCmp.value && !hasDecided.value);

const privacyUrl = computed(
	() => (runtimeConfig.public.privacyPolicyUrl as string) || ""
);
</script>
